import * as React from 'react';
import { Text, Tooltip, Flex } from '@radix-ui/themes';

export function MenuItem({flag, state, onClick, text, tooltip, icon}) {

  const color = state === flag ? "var(--gray-a3)" : null;

  return (
    <button
      className="sidebar-item" 
      style={{
        display: "flex", 
        height: "var(--space-6)", 
        padding: "6px var(--space-3)", 
        alignItems: "center", 
        gap: "var(--space-2)", 
        alignSelf: "stretch", 
        borderRadius: "var(--space-1)", 
        background: color,
        cursor: "default"
      }}
      onClick={() => onClick(flag)}
    >
      <Tooltip content={tooltip} side="right" align="center" delayDuration={300} sideOffset={10}>
        <Flex gap="2" align="center" style={{ flex: "1 0 0", alignItems: "center", minWidth: 0 }}>
          {icon}
          <Text size="2" weight="medium">{text}</Text>
        </Flex>
      </Tooltip>
    </button>
  );
}